<template>
    <div class="columns">
        <div class="column is-4 is-settings-label">
            <div class="field">
                <strong>Current Password</strong>
                <span>Your current account password.</span>
            </div>
        </div>
        <div class="column is-5 is-offset-1">
            <form-input
                v-model="form.current_password"
                type="password"
                placeholder="Enter Your Password"
                autocomplete="current-password"
                :error="form.errors.get('current_password')"
            />
        </div>
    </div>
</template>

<script>
import Form from 'core/Form';

export default {
    props: {
        form: { type: Form, required: true },
    },
};
</script>
